import * as EmailValidator from 'email-validator'

export const validateEmail = (email: string | null | undefined): boolean => {
  if (!email) return false
  return EmailValidator.validate(email)
}
